import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getReasonCodeSlice = createApi(`GetReasonCodeSlice`,"GET");

const GetReasonCodeSlice = createSlice({
  name: 'GetReasonCodeSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReasonCodeSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReasonCodeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getReasonCodeSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetReasonCodeSlice.reducer;